import { ComponentChildren, h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./RightPanelPropertyCell.module.css";

interface Props {
    class?: string;
    name?: string;
    valueTitle?: string;
    abbr?: string;
    children?: ComponentChildren;
    capitalize?: boolean;
    padding?: "s" | "xs";
    onMouseEnterValue?: () => void;
    onMouseLeaveValue?: () => void;
}

function RightPanelPropertyCell({
    class: cssClass,
    name,
    valueTitle,
    abbr,
    children,
    capitalize = true,
    padding = "s",
    onMouseEnterValue,
    onMouseLeaveValue
}: Props) {
    function handleMouseEnterValue() {
        if (onMouseEnterValue) {
            onMouseEnterValue();
        }
    }

    function handleMouseLeaveValue() {
        if (onMouseLeaveValue) {
            onMouseLeaveValue();
        }
    }

    const displayName = name ? `${name}` : null;
    const displayAbbr = abbr ? <abbr>{abbr}</abbr> : null;
    const separator = displayName && displayAbbr ? ", " : "";
    const paddingClass = padding === "s" ? styles.paddingS : styles.paddingXS;

    return (
        <div class={classname(styles.rightPanelPropertyCell, paddingClass, "body-1", cssClass, { [styles.capitalize]: capitalize })}>
            {(displayName || displayAbbr) && (
                <span class={classname(styles.name, "ellipsis", "noSelect")} title={name}>
                    {displayName}{separator}{displayAbbr}:
                </span>
            )}
            <span
                class={classname(styles.value, "ellipsis")}
                title={valueTitle}
                onMouseEnter={handleMouseEnterValue}
                onMouseLeave={handleMouseLeaveValue}>
                {children}
            </span>
        </div>
    );
}

function RightPanelPropertyCellGroup({ children }: { children: ComponentChildren; }) {
    return (
        <div class={styles.rightPanelPropertyCellGroup}>
            {children}
        </div>
    );
}

function RightPanelPropertyCellSideBySide({ children }: { children: ComponentChildren; }) {
    return (
        <div class={styles.rightPanelPropertyCellSideBySide}>
            {children}
        </div>
    );
}

RightPanelPropertyCell.Group = RightPanelPropertyCellGroup;
RightPanelPropertyCell.SideBySide = RightPanelPropertyCellSideBySide;

export default RightPanelPropertyCell;
export { Props as RightPanelPropertyCellProps };
